const getters = {
  filterDate: state => state.filterDate,
  currentTab: state => state.currentTab
}
export default getters